<template>
    <div>
        <xi-top></xi-top>
        <div class="baseInfo" v-loading.fullscreen="loading">
            <div class="top">
                <h1>{{ $t('comb.releaseTask') }}</h1>
            </div>
            <el-form :model="task" label-position="top" :rules="rules" ref="task" class="form">
                <el-tabs v-model="activeName">
                    <el-tab-pane name="baseInfo" :disabled="true">
                        <div class="tab-slot-wrapper" slot="label">
                            <div class="tabs-item first-item">{{ $t('comb.baseInfo') }}</div>
                            <div class="arrow-right"></div>
                        </div>
                        <el-form-item size="large" :label="multiTaskName" prop="taskName" :required="true">
                            <el-input type="text" v-model="task.taskName"></el-input>
                        </el-form-item>
                        <el-form-item size="large" :label="multiTaskCategory" :required="true" ref="taskType">
                            <el-cascader
                                     :props="categoryProps"
                                     @change="changeCategoryType"
                                     expand-trigger="hover"
                                     :show-all-levels="false"
                                     :options="categoryList"
                                     v-model="task.category"
                                     filterable>
                            </el-cascader>
                        </el-form-item>
                        <el-form-item :label="multiTaskCover" :required="true">
                            <label>{{ $t('sen.pictureUploadLimit') }}</label>
                        </el-form-item>
                        <el-form-item prop="coverImgUrl" :required="true">
                            <el-upload action="/dtres/backend/album/upload" type="drag"
                                       :show-file-list="false" :v-model="task.coverImgUrl"
                                       :before-upload="uploadBefore" :multiple="false"
                                       :on-success="uploadSuccess" :file-list="fileList">
                                <img v-if="task.coverImgUrl" :src="uploadedPic" class="wrapper-upload-small">
                                <div v-else class="wrapper-upload-small">
                                    <i class="el-icon-plus"></i>
                                </div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item :label="multiTaskIntro" prop="taskDescription">
                            <el-input :maxlength="2000" type="textarea" v-model="task.taskDescription"></el-input>
                        </el-form-item>
                        <el-button class="submit-button" type="primary" @click="nextTab('cooperationInfo')">{{ $t('word.nextStep') }}</el-button>
                    </el-tab-pane>
                    <el-tab-pane name="cooperationInfo" :disabled="true">
                        <div class="tab-slot-wrapper" slot="label">
                            <div class="tabs-item second-item">{{ $t('comb.taskRequirement') }}</div>
                            <div class="arrow-right"></div>
                        </div>
                        <el-form-item style="width: 598px;" :required="true">
                            <el-row>
                                <el-col>
                                    <span class="form-item-label">{{ multUpdateFrequency }}</span>
                                    <el-tooltip class="tips" effect="dark" placement="right">
                                        <div slot="content">提示：每集约为20分钟</div>
                                        <span>?</span>
                                    </el-tooltip>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-select type="text" v-model="task.frequency">
                                    <el-option v-for="item in $store.state.publishFrequency"
                                               :label="item" :value="item"></el-option>
                                </el-select>
                            </el-row>
                        </el-form-item>
                        <el-form-item :label="muiltDisplayWay" :required="true">
                            <el-select type="text" v-model="task.playMode">
                                <el-option v-for="item in $store.state.playMode"
                                           :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="muiltReleaseMode" :required="true">
                            <el-select type="text" v-model="task.publishMethod" @change="changePublishMethod">
                                <el-option v-for="item in $store.state.publishMethods"
                                           :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="width: 598px;" prop="basePay" :required="true">
                            <el-row>
                                <el-col>
                                    <span class="form-item-label">{{ muiltTaskPay }}</span>
                                    <el-tooltip class="tips" effect="dark" placement="right">
                                        <div slot="content">提示：任务酬劳不低于100元每小时。<br>酬劳越高，将有更多主播参与海选，您选中合适主播的概率越高。</div>
                                        <span>?</span>
                                    </el-tooltip>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-input-number class="center" :controls="false" style="width: 240px" v-model="task.basePay"></el-input-number><span style="line-height: 52px;vertical-align: text-bottom;">元/小时</span>
                            </el-row>
                        </el-form-item>
                        <div class="buttons">
                            <el-button class="submit-button" type="default" @click="nextTab('baseInfo')">{{ $t('word.prevStep') }}</el-button>
                            <el-button class="submit-button" type="primary" @click="nextTab('additionInfo')">{{ $t('word.nextStep') }}</el-button>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="additionInfo" :disabled="true">
                        <div class="tab-slot-wrapper" slot="label">
                            <div class="tabs-item third-item">{{ $t('comb.additionRequirement') }}</div>
                            <div class="arrow-right"></div>
                        </div>
                        <el-form-item :label="muiltAdditionRequirement" prop="additionRequirement">
                            <el-input type="textarea" v-model="task.additionRequirement"></el-input>
                        </el-form-item>
                        <el-form-item size="large" prop="additionLimit" :label="muiltAdditionCycle" :required="true">
                            <el-select type="text" v-model="task.additionLimit">
                                <el-option v-for="item in $store.state.additionLimits"
                                           :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="试音内容" prop="sampleMaterialText" :required="true">
                            <el-input type="textarea" placeholder="请输入1000~2000字的试音内容" v-model="task.sampleMaterialText"></el-input>
                        </el-form-item>
                        <div class="buttons">
                            <el-button class="submit-button" type="default" @click="nextTab('cooperationInfo')">{{ $t('word.prevStep') }}</el-button>
                            <el-button class="submit-button" type="primary" @click="nextTab('preview')">{{ $t('word.nextStep') }}</el-button>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="preview" :disabled="true">
                        <div class="tab-slot-wrapper" slot="label">
                            <div class="tabs-item fourth-item">确认任务</div>
                        </div>
                        <div class="data-wrapper">
                            <div class="data-row">
                                <span class="data-label">任务类型</span>
                                <span class="data-value">{{ task.categoryLabel }}</span>
                            </div>
                            <div class="data-row">
                                <span class="data-label">发布方式</span>
                                <span class="data-value colored">{{ task.publishMethodLabel }}</span>
                            </div>
                            <div class="data-row">
                                <span class="data-label">任务名称</span>
                                <span class="data-value colored">{{ task.taskName }}</span>
                            </div>
                            <div class="data-row">
                                <span class="data-label">关联版权</span>
                                <span class="data-value">{{ task.bookName }}</span>
                            </div>
                            <div class="data-row">
                                <span class="data-label">更新频率</span>
                                <span class="data-value">{{ task.frequency }}，每集约20分钟</span>
                            </div>
                            <div class="data-row">
                                <span class="data-label">演绎方式</span>
                                <span class="data-value">{{ $store.state.playMode[task.playMode-1].label }}</span>
                            </div>
                            <hr>
                            <div class="data-row">
                                <span class="data-label">招募方式</span>
                                <span class="data-value">海选选拔</span>
                            </div>
                            <div class="data-row">
                                <span class="data-label">招募人数</span>
                                <span class="data-value">1人</span>
                            </div>
                            <div class="data-row">
                                <span class="data-label">海选期限</span>
                                <span class="data-value">{{ task.additionLimit }}天</span>
                            </div>
                            <hr>
                            <div class="data-row">
                                <span class="data-label">演播字数</span>
                                <span class="data-value colored">{{ task.words }}</span><span>字</span>
                            </div>
                            <div class="data-row">
                                <span class="data-label">预计时长</span>
                                <span class="data-value colored">{{ task.et }}</span><span>小时</span>
                            </div>
                            <div class="data-row">
                                <span class="data-label">任务酬劳</span>
                                <span class="data-value colored">{{ task.basePay }}</span><span>元/小时</span>
                            </div>
                            <div class="data-row">
                                <span class="data-label">预计总酬劳</span>
                                <span class="data-value colored">{{ task.basePay?(task.basePay * task.et).toFixed(2):0 }}</span><span>元</span>
                            </div>
                        </div>
                        <div class="buttons">
                            <el-button class="submit-button" type="default" @click="nextTab('additionInfo')">{{ $t('word.prevStep') }}</el-button>
                            <el-button class="submit-button" type="primary" @click="nextStep('task')">{{ $t('comb.commitConfirm') }}</el-button>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-form>
        </div>
        <xi-footer></xi-footer>
    </div>
</template>
<script>
    import axios from 'axios';
    import each from 'lodash/each';
    import XiFooter from '../../components/Footer.vue';
    import XiTop from '../../components/Top.vue';
    export default{
        data() {
            // 主播分成比例验证
            var sharePercentageCheck = (rule, value, callback) => {
              if (value%1 !== 0) {
                callback(new Error('主播分成比例必须是整数'))
              } else if (!value && value != 0) {
                callback(new Error('请填写主播分成比例'))
              } else if (value > 100-this.platformRoyaltyShareRatio) {
                callback(new Error('主播分成比例与平台分成之和不能大于100'))
              } else if (value < 0) {
                callback(new Error('主播分成比例不能小于0'))
              } else {
                callback()
              }
            };
            // 每集酬劳验证
            var basePayCheck = (rule, value, callback) => {
              if (value<100) {
                callback(new Error('主播底薪必须大于100！'))
              } else {
                callback()
              }
            };
            return {
              loading: false,
              activeName: 'baseInfo',
              categoryProps: {
                value: 'categoryId',
                label: 'name'
              },
              isSolo: false,      //是否独家
              isDisabled: false,
              books: [],
              categoryList: [],
              additionLimits: ['3天', '7天', '10天', '15天'],
              platformRoyaltyShareRatio: 40,
              task: {
                categoryLabel: '',
                publishMethodLabel: '',
                frequency: '每天1集',
                playMode: 1,
                publishMethod: 2,
                currentBook: '',
                requirementId: '',
                materialId: '',
                taskName: '',
                bookName: '',
                category: [1, 6],
                coverImgUrl: '',
                sampleMaterialText: '',
                sampleMaterialUrl: '',
                taskDescription: '',
                amount: '',
                basePay: '',
                percentagePay: '',
                additionRequirement: '',
                additionLimit: '',
                et: '',
                words: 0
              },
              previewFile: [],
              fileList: [],
              rules: {
                percentagePay: [
                  { validator: sharePercentageCheck,  trigger: 'change'}
                ],
                basePay: {
                  validator: basePayCheck, trigger: 'blur'
                },
                currentBook: [
                  { required: true, type: 'object', message: this.$i18n.t('sen.chooseSpecifyWork'), trigger: 'change'}
                ],
                taskName: [
                  { required: true, message: this.$i18n.t('sen.taskNameMissing'), trigger: 'blur' }
                ],
                taskType: [
                  { required: true, type: 'number', message: this.$i18n.t('sen.typeMissing'), trigger: 'change' }
                ],
                coverImgUrl: [
                  { required: true, message: this.$i18n.t('sen.coverImgMissing'), trigger: 'change' }
                ],
                sampleMaterialText: [
                  { required: true, min: 1000, max: 2000, message: '试音内容长度应在1000~2000个字符', trigger: 'blur' }
                ],
                additionLimit: [
                  { required: true, type: 'number', message: this.$i18n.t('sen.additionLimitMissing'), trigger: 'change' }
                ]
              }
            }
        },
        methods: {
            nextTab(tab) {
                this.activeName = tab;
            },
            nextStep(form) {
                const that = this;
                that.$refs[form].validate( (valid) => {
                    if (valid) {
                        that.loading = true;
                        let data = {
                            materialId: that.task.materialId,
                            name: that.task.taskName,
                            bookName: that.task.bookName,
                            categoryId: that.task.category[that.task.category.length-1],
                            description: that.task.taskDescription,
                            coverPath: that.task.coverImgUrl,
                            sampleMaterialUrl: that.task.sampleMaterialUrl,
                            sampleMaterialText: that.task.sampleMaterialText,
                            distributionOptionId: that.task.publishMethod,
                            demandStudioTypeId: that.task.playMode,
                            demandDeliveryFrequency: that.task.frequency,
                            priceOfHours: that.task.basePay,
                            royaltyShareRatio: that.task.percentagePay,
                            sampleDurationInDays: that.task.additionLimit,
                            sampleRequirement: that.task.additionRequirement,
                            totalChapter: that.task.amount,
                            estimatedHours: that.task.et,
                            words: that.task.words
                        };
                        if (that.task.basePay && that.isPositiveInteger(that.task.basePay)) {
                          axios.post(`/api/requirement/publish`, data).then(res => {
                            if (res.data.code === 200) {
                              if(that.task.basePay > 0) {
                                that.$router.push({
                                  name: 'toPayPage',
                                  params: {requirementId: res.data.data},
                                  query: {materialId: that.task.materialId}
                                });
                              } else {
                                that.$router.push({
                                  name: 'taskManagementList',
                                  query: {subTab: 'mass'}
                                });
                              }
                            } else {
                              that.loading = false;
                              that.$message({
                                type: 'warning',
                                message: res.data.message,
                                duration: 1500
                              });
                            }
                          });
                        } else {
                          that.loading = false;
                          that.$message({
                            type: 'warning',
                            message: '主播底薪必须是大于0的正整数！',
                            duration: 1500
                          });
                        }
                    } else {
                        that.$message({
                            type: 'error',
                            message: this.$i18n.t('sen.infoErrorRecommitPlease'),
                            duration: 1000
                        });
                        return false;
                    }
                });
            },
            uploadBefore (file) {
                console.log('file.size: ', file.size);
                // 限制文件大小 (大图标5M以下)
                if (parseInt(file.size) > 5 * 1024 * 1024) {
                    this.$message.error(this.$i18n.t('sen.bigIconSizeLimit'));
                    return false
                }
            },
            uploadSuccess (response, file, fileList) {
                this.task.coverImgUrl = response.data[0].dfsId;
                this.$refs['task'].validateField('coverImgUrl');
            },
            changeCategoryType() {
              this.getTaskCategoryLabel();
            },
            changePublishMethod() {
              this.getPublishMethodLabel();
            },
            getPublishMethodLabel() {
              const that = this;
              const publishMethod = that.task.publishMethod;
              const publishMethodList = that.$store.state.publishMethods;
              each(publishMethodList, item => {
                if (publishMethod === item.value) {
                  that.task.publishMethodLabel = item.label;
                  return
                }
              });
            },
            getTaskCategoryLabel () {
              const that = this;
              const categoryId = that.task.category[that.task.category.length-1];
              each(that.categoryList, topLevel => {
                if(!topLevel.children) {
                  if(categoryId === topLevel.categoryId) {
                    that.task.categoryLabel = topLevel.name;
                    return;
                  }
                } else {
                  each(topLevel.children, subLevel => {
                    if(categoryId === subLevel.categoryId) {
                      that.task.categoryLabel = topLevel.name + '-' + subLevel.name;
                      return;
                    }
                  });
                }
              });
            },
            getTaskTypes() {
              const that = this;
              axios.get('/api/audio/categories').then(res => {
                const list = res.data.data;
                each(list, topLevel => {
                  if(topLevel.children.length === 0) {
                    delete topLevel.children;
                  } else {
                    each(topLevel.children, subLevel => {
                      delete subLevel.children;
                    });
                  }
                });
                that.categoryList = list;
              }).catch(error => {
                that.$message({
                  type: 'error',
                  message: error.message
                });
              });
            },
            getBookDetail() {
                let that = this;
                axios.get(`/api/requirement/book/${this.$route.query.id}`).then(res => {
                    // 成功
                    if (res.data.code === 200) {
                        const categoryArray = [];
                        const taskBook = res.data.data;
                        that.task.taskName = taskBook.name;
                        that.task.bookName = taskBook.name;
                        that.task.materialId = taskBook.materialId;
                        that.task.coverImgUrl = taskBook.coverPath;
                        that.task.sampleMaterialText = taskBook.sampleMaterialText;
                        that.task.sampleMaterialUrl = taskBook.sampleMaterialUrl;
                        that.platformRoyaltyShareRatio = taskBook.platformRoyaltyShareRatio;
                        that.fileList = [{coverImgUrl: that.$store.state.UPLOAD_IMG_HOST+ taskBook.coverPath}];
                        that.task.taskDescription = taskBook.description;
                        that.task.et = taskBook.estimatedHours;
                        that.task.words = taskBook.words;
                        if (taskBook.parentCategoryId) {
                          categoryArray.push(taskBook.parentCategoryId);
                        }
                        categoryArray.push(taskBook.categoryId);
                        that.task.category = categoryArray;
                        that.getTaskCategoryLabel();
                        that.getPublishMethodLabel();
                    } else {
                      this.$message({
                        type: 'error',
                        message: res.data.message
                      });
                    }
                });
            },
            isPositiveInteger(number) {
                var re = /^[0-9]+$/;
                return re.test(number);
            }
        },
        computed: {
            IMG_HOST(){
                return  this.$store.state.IMG_HOST;
            },
            uploadedPic() {
                return this.$store.state.UPLOAD_IMG_HOST+this.task.coverImgUrl;
            },
            multiWorkSelection() {
                return this.$i18n.t('comb.workSelection');
            },
            multiTaskName() {
                return this.$i18n.t('comb.taskName');
            },
            multiTaskCategory() {
                return this.$i18n.t('comb.taskCategory');
            },
            multiTaskCover() {
                return this.$i18n.t('comb.taskCover');
            },
            multiTaskIntro() {
                return this.$i18n.t('comb.taskIntro');
            },
            multUpdateFrequency () {
                return this.$i18n.t('comb.updateFrequency');
            },
            muiltBaseInfo () {
                return this.$i18n.t('comb.baseInfo')
            },
            muiltTaskRequirement () {
                return this.$i18n.t('comb.taskRequirement')
            },
            muiltAdditionRequirement () {
                return this.$i18n.t('comb.additionRequirement')
            },
            muiltDisplayWay () {
                return this.$i18n.t('comb.displayWay')
            },
            muiltAmountOfEpisode () {
                return this.$i18n.t('comb.amountOfEpisode')
            },
            muiltReleaseMode () {
                return this.$i18n.t('comb.releaseMode')
            },
            muiltTaskPay () {
              return this.$i18n.t('comb.taskPay')
            },
            muiltAdditionRequirement () {
              return this.$i18n.t('comb.additionRequirement')
            },
            muiltAdditionCycle () {
              return this.$i18n.t('comb.additionCycle')
            }
        },
        created () {
            this.getBookDetail();
            this.getTaskTypes();
        },
        components: {
          XiFooter,
          XiTop
        },
    }
</script>
<style lang="sass">@import "../../../sass/copyright/publishTask/baseInfo.scss";</style>



// WEBPACK FOOTER //
// BaseInfo.vue?20ccb5da